import { Grid, TextField, Typography } from '@mui/material';
import { CardComponent } from 'utils/components/card/CardComponent';
import { sanitizeInput } from 'utils/helpers/sanitizeInput/sanitizeInput';

export const TaxDataForm = ({ register, errors, taxDataValidations, setValue }) => {
  return (
    <CardComponent title='Datos fiscales' minWidth='100%'>
      <Grid container spacing={3} sx={{ width: '100%' }} mt={3}>
        <Grid size={{ xs: 12 }}>
          <Typography gutterBottom sx={{ fontSize: 14, fontWeight: 600 }}>
            RFC
          </Typography>
          <TextField
            fullWidth
            disabled
            placeholder='RFC'
            {...register('rfc', taxDataValidations.rfc)}
            error={Boolean(errors.rfc)}
            helperText={errors.rfc?.message}
            onChange={(event) => {
              const cleaned = sanitizeInput(event.target.value, 'rfc');
              setValue('rfc', cleaned, { shouldDirty: true });
            }}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography gutterBottom sx={{ fontSize: 14, fontWeight: 600 }}>
            Razón social
          </Typography>
          <TextField
            fullWidth
            placeholder='Nombre legal de la empresa'
            {...register('legalName', taxDataValidations.legalName)}
            error={Boolean(errors.legalName)}
            helperText={errors.legalName?.message}
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography gutterBottom sx={{ fontSize: 14, fontWeight: 600 }}>
            Nombre comercial
          </Typography>
          <TextField
            fullWidth
            placeholder='Nombre completo'
            {...register('tradeName', taxDataValidations.tradeName)}
            error={Boolean(errors.tradeName)}
            helperText={errors.tradeName?.message}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography gutterBottom sx={{ fontSize: 14, fontWeight: 600 }}>
            Código postal
          </Typography>
          <TextField
            type='tel'
            fullWidth
            placeholder='Código postal'
            {...register('legalZipCode', taxDataValidations.legalZipCode)}
            error={Boolean(errors.legalZipCode)}
            helperText={errors.legalZipCode?.message}
            onChange={(event) => {
              const cleaned = sanitizeInput(event.target.value, 'digits');
              setValue('legalZipCode', cleaned, { shouldDirty: true });
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography gutterBottom sx={{ fontSize: 14, fontWeight: 600 }}>
            Dirección
          </Typography>
          <TextField
            fullWidth
            placeholder='Dirección'
            {...register('legalAddress', taxDataValidations.legalAddress)}
            error={Boolean(errors.legalAddress)}
            helperText={errors.legalAddress?.message}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography gutterBottom sx={{ fontSize: 14, fontWeight: 600 }}>
            Teléfono de contacto
          </Typography>
          <TextField
            type='tel'
            fullWidth
            placeholder='Número telefónico'
            {...register('contactPhone', taxDataValidations.contactPhone)}
            error={Boolean(errors.contactPhone)}
            helperText={errors.contactPhone?.message}
            onChange={(event) => {
              const cleaned = sanitizeInput(event.target.value, 'digits');
              setValue('contactPhone', cleaned, { shouldDirty: true });
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <Typography gutterBottom sx={{ fontSize: 14, fontWeight: 600 }}>
            Correo electrónico
          </Typography>
          <TextField
            fullWidth
            placeholder='correo@empresa.com'
            {...register('contactEmail', taxDataValidations.contactEmail)}
            error={Boolean(errors.contactEmail)}
            helperText={errors.contactEmail?.message}
            onChange={(event) => {
              const cleaned = sanitizeInput(event.target.value, 'email');
              setValue('contactEmail', cleaned, { shouldDirty: true });
            }}
          />
        </Grid>
      </Grid>
    </CardComponent>
  );
};
